var map = {
	"./arrow-circle.svg": "bd43",
	"./arrow.svg": "21e2",
	"./cart.svg": "daca",
	"./check-text.svg": "e29e",
	"./check.svg": "7bae",
	"./close.svg": "8b1b",
	"./coating-dirt.svg": "c4bb",
	"./coating-reflection.svg": "e8f8",
	"./coating-scratch.svg": "63b1",
	"./coating-static.svg": "5239",
	"./coating-water.svg": "30fc",
	"./coating-xtraclean.svg": "3bf8",
	"./coloring-slider-cloud.svg": "714c",
	"./coloring-slider-house.svg": "1e1c",
	"./coloring-slider-sun.svg": "0ce4",
	"./delete.svg": "0d45",
	"./glasses.svg": "f112",
	"./glassthickness-minus.svg": "1bde",
	"./glassthickness-plus.svg": "5403",
	"./glassthicknessminus-15.svg": "aae0",
	"./glassthicknessminus-16.svg": "9d2a",
	"./glassthicknessminus-167.svg": "2313",
	"./glassthicknessminus-174.svg": "87a8",
	"./glassthicknessplus-15.svg": "7676",
	"./glassthicknessplus-16.svg": "abe8",
	"./glassthicknessplus-167.svg": "1f54",
	"./glassthicknessplus-174.svg": "96ad",
	"./glasstype-lenses.svg": "68fd",
	"./glasstype-multifocal.svg": "6e3b",
	"./glasstype-multifocalsunglasses.svg": "11a73",
	"./glasstype-reading.svg": "34c3",
	"./glasstype-screen.svg": "9b22",
	"./glasstype-single.svg": "2b36",
	"./glasstype-singlesunglasses.svg": "195e",
	"./glasstype-sport.svg": "6e5d",
	"./home.svg": "ac9d",
	"./index-home.svg": "d3d0",
	"./index-lenses.svg": "1c71",
	"./index-multifocal.svg": "d574",
	"./index-multifocalsunglasses.svg": "4e68",
	"./index-reading.svg": "f078",
	"./index-screen.svg": "a2cb",
	"./index-single.svg": "1f04",
	"./index-singlesunglasses.svg": "b62b",
	"./index-sport.svg": "6901",
	"./info.svg": "76ed",
	"./lifestyle-style-active.svg": "444a",
	"./lifestyle-style-allround.svg": "6a5c",
	"./lifestyle-style-expert.svg": "201c",
	"./logo.svg": "5b1c",
	"./options-antireflection.svg": "2f29",
	"./options-aspherical.svg": "313e",
	"./options-color.svg": "0516",
	"./options-coloring.svg": "5d99",
	"./options-dneye.png": "af56",
	"./options-glassthickness.svg": "0e51",
	"./options-grinding.svg": "da59",
	"./options-impressionist.png": "13a9",
	"./options-lifestyle.svg": "558f",
	"./options-mdm.svg": "9d3d",
	"./options-monoplus.svg": "95fc",
	"./options-prisma.svg": "4654",
	"./options-pro410.svg": "7fb3",
	"./pdf.svg": "5730",
	"./present.svg": "4577",
	"./print.svg": "671e",
	"./profile-female.svg": "4bcf",
	"./profile-home.svg": "3f68",
	"./profile-male.svg": "a7e8",
	"./profile.svg": "95dc",
	"./rating-1.svg": "20c4",
	"./rating-2.svg": "3998",
	"./rating-3.svg": "2d58",
	"./rating-smiley-1.svg": "eb47",
	"./rating-smiley-2.svg": "ed72",
	"./rating-smiley-3.svg": "a175",
	"./save.svg": "9344",
	"./search.svg": "d103",
	"./slider.svg": "df4b",
	"./swap.svg": "b008",
	"./user.svg": "6aed",
	"./video-play.svg": "e488"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";